import { css } from "@emotion/css";
import colors from "src/utils/colors";

const CardElementContainer = (props) => (
  <div
    {...props}
    className={css`
      border: 1px solid ${colors.borderGray};
      border-radius: 6px;
      height: 44px;
      padding: 0.8rem 1rem 0 1rem;
      margin: 0 0 1.5rem 0;
      background: ${colors.bgGray};
    `}
  />
);

export default CardElementContainer;
